import { Reducer } from 'redux';

import {
    RunAuditWorkpapersActions,
    KnownAction,
} from './Actions';

export interface IRunAuditWorkpapersState {
    // Whether the Run Audit Workpapers modal is currently active (shown).
    modalActive: boolean;
    // The workspace (entity) id for the submission the modal was launched from.
    workspaceId: string;
    // The submission id the Run Audit Workpapers button was clicked on.
    submissionId: string;
    // The financial record id for the submission the modal was launched from.
    financialRecordId: string;
}

const defaultState: IRunAuditWorkpapersState = {
    modalActive: false,
    workspaceId: '',
    submissionId: '',
    financialRecordId: '',
}

export const reducer: Reducer<IRunAuditWorkpapersState, KnownAction> = (state: IRunAuditWorkpapersState | undefined, action: KnownAction): IRunAuditWorkpapersState => {
    switch (action.type) {
        case RunAuditWorkpapersActions.ShowModal: {
            return {
                ...(state ? state : defaultState),
                modalActive: true,
                workspaceId: action.workspaceId,
                submissionId: action.submissionId,
                financialRecordId: action.financialRecordId,
            }
        }
        case RunAuditWorkpapersActions.HideModal: {
            return {
                ...(state ? state : defaultState),
                modalActive: false,
                workspaceId: '',
                submissionId: '',
                financialRecordId: '',
            }
        }
    }

    return state ? state : defaultState;
}
